/**
 * gridArrowUp.tsx
 */
import GridArrowUpContainer from '@components/atoms/container/gridArrowUpContainer';
import ArrowUpIcon from '@components/atoms/icons/arrowUp';
import MosaicContext from '@shared/components/utils/context/mosaicContext';
import { useContext, useMemo } from 'react';

/**
 * GridArrowUp component.
 */
export default function GridArrowUp() {
  // Context
  const { config, index } = useContext(MosaicContext);

  // Memoized values
  const displayArrow = useMemo(() => {
    return config.minimumIndex && index >= config?.minimumIndex;
  }, [config, index]);

  // Render
  return displayArrow ? (
    <GridArrowUpContainer>
      <ArrowUpIcon width={34} height={20} />
    </GridArrowUpContainer>
  ) : null;
}
